<template>
  <v-app>
    <v-treeview
      v-model="selection"
      activatable
      :items="items"
      @update:active="onUpdate"
      item-key="id"
    >
      <template v-slot:prepend="{ item, open }">
        <v-icon v-if="!item.file">
          {{ open ? "mdi-folder-open" : "mdi-folder" }}
        </v-icon>
        <v-icon v-else>
          {{ files[item.file] }}
        </v-icon>
      </template>
    </v-treeview>
  </v-app>
</template>
<script>
import axios from "axios";
import baseURL from "@/axios";
export default {
  props: ["items", "select1", "productGroupId"],
  data: () => ({
    selection: this.select1,
    items: this.items,
  }),
  watch: {
    selection(newValue) {
      ////////console.log(newValue);
      this.onUpdate(newValue);
    },
  },
  methods: {
    onUpdate(selection) {
      axios
        .get(`${baseURL}ProductGroup/GetById?id=${selection}`, {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("token")}`,
          },
        })
        .then((res) => {
          this.$emit("treeValue", res.data.data.parentId);
          // this.$emit("treeValue1", res.data.data.id);
          this.$emit("productCategory", res.data.data.id);
          this.$emit("treeFeatures", res.data.data.features);
          this.$emit("treeBrands", res.data.data.Brands);
        });
    },
    onCreate(selection) {
      if (selection) {
        axios
          .get(`${baseURL}ProductGroup/GetById?id=${selection}`, {
            headers: {
              Authorization: `Bearer ${sessionStorage.getItem("token")}`,
            },
          })
          .then((res) => {
            this.$emit("treeValue", res.data.data.parentId);
            this.$emit("productCategory", res.data.data.id);
            this.$emit("treeFeatures", res.data.data.features);
            this.$emit("treeBrands", res.data.data.Brands);
          });
      }
    },
  },
};
</script>